import React from 'react';
import moment from 'moment';
import { Timeline } from 'antd-v5';
import { PurchaseOutline } from '../../../../../componentsV2/Layout/Report/components/Icons';
import SalesTimelineItem from '../../../../../componentsV2/Layout/Report/components/SalesTimelineItem';
import TimelineItem from '../../../../../componentsV2/Layout/Report/components/Timeline';
import { CalendarOutlined } from '@ant-design/icons';

const AppointmentsExpandRow = ({ record, licenseKey }) => {
  const { client_name, appointment_name, activity_date, transactions } = record;
  return (
    <div className="m-left-23">
      <div className="flex-row-spacebetween-nowrap">
        <Timeline
          items={[
            {
              children: <TimelineItem
                title={
                  <>
                    <span className="fw-600">{client_name} </span>scheduled a <span className="fw-600">{`${appointment_name}`} </span>
                    appointment on
                    <span className="fw-600"> {moment(activity_date).format('MMM DD, YYYY')}</span>
                  </>
                }
              />,
              dot: <CalendarOutlined style={{ opacity: 0.45, color: "#000", fontSize: '20px' }} />
            },
            ...transactions.map(({sales_transaction_amount, description, sales_transaction_date}) => ({
              dot: <PurchaseOutline style={{ color: '#389E0D', fontSize: '18px'}} />,
              children: <SalesTimelineItem
                client_name={client_name}
                sales_transaction_amount={sales_transaction_amount}
                description={description}
                activity_date={sales_transaction_date}
              />
            }))
          ]}
        />
        {/* <Button onClick={() => history.push(`/Clients?client=${client_id}`)}>View Details</Button> */}
      </div>
    </div>
  );
};
export default AppointmentsExpandRow;

